import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'games'
    }
  },
  {
    name: 'games',
    path: '/games',
    component: () => import('./view/Games'),
    meta: {
      title: '手游账号免费估价 . 淘手游'
    }
  },
  {
    name: 'game',
    path: '/game-:id',
    component: () => import('./view/Game'),
    meta: {
      title: '手游账号免费估价 . 淘手游'
    }
  },
  {
    name: 'result',
    path: '/game-:id/result',
    component: () => import('./view/Result'),
    meta: {
      title: '手游账号免费估价 . 淘手游'
    }
  },
  {
    name: 'history',
    path: '/game-:id/history',
    component: () => import('./view/History'),
    meta: {
      title: '手游账号免费估价 . 淘手游'
    }
  }
]

const router = createRouter({
  routes,
  history: createWebHashHistory()
})

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', location.pathname + '#' + to.fullPath])
    }
  }
  next()
})

export { router }
